import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter";

//import components
import BusItem from "./bus-item";

//import images
import BusImage from "../../../assets/imgs/bus-default.jpg";

export default function BusList({ list, uid, requestExpirationDate }) {
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const uidData = {
        uid,
        requestExpirationDate,
    };

    const handleSelectedTicket = ticket => {
        sessionStorage.setItem("selectedBus", JSON.stringify(ticket));
        sessionStorage.setItem("uidData", JSON.stringify(uidData));
        navigate(`/${locale}/bus-passengers`);
    };

    return (
        <Grid container item xs={12} rowGap={2}>
            {list?.map(item => {
                const { id, move_date, move_time, price, origin, destination, company_name, bus_type, available_seats, source_code, bus_code, logo } =
                    item;
                return (
                    <BusItem
                        key={id}
                        uid={uid}
                        labels={[bus_type, bus_code]}
                        companyLogo={logo || BusImage}
                        companyName={company_name}
                        ticketDate={move_date.replaceAll("-", "/")}
                        departureTime={move_time}
                        origin={origin?.name}
                        destination={destination?.name}
                        price={price}
                        capacity={available_seats}
                        sourceCode={source_code}
                        busCode={bus_code}
                        onSelect={() => handleSelectedTicket(item)}
                    />
                );
            })}
        </Grid>
    );
}
